import { apiInstance } from 'api/utils';

const chartsApi = {
  // recommendation/ips past performance
  getPastPerformanceData: ({
    portfolio,
    data = {}
  }: {
    portfolio: string;
    data?: any;
  }) =>
    apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/charts/past-performance/`,
      data
    }),
  // recommendation asset allocation chart
  getAssetAllocationData: (
    { portfolio }: { portfolio: string },
    portfolioType?: string
  ) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/charts/portfolio-asset-allocation/${
        portfolioType ? `?portfolioType=${portfolioType}` : ''
      }`
    }),
  getSectorBreakdownData: (
    { portfolio }: { portfolio: string },
    portfolioType?: string
  ) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/charts/portfolio-sector-breakdown/${
        portfolioType ? `?portfolioType=${portfolioType}` : ''
      }`
    }),
  getCountryBreakdownData: (
    { portfolio }: { portfolio: string },
    portfolioType?: string
  ) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/charts/portfolio-country-breakdown/${
        portfolioType ? `?portfolioType=${portfolioType}` : ''
      }`
    }),
  getRegionalBreakdownData: (
    { portfolio }: { portfolio: string },
    portfolioType?: string
  ) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/charts/portfolio-regional-breakdown/${
        portfolioType ? `?portfolioType=${portfolioType}` : ''
      }`
    }),
  // IPS charges existing policies && policy analysis
  getExsitinPoliciesChargesData: ({ portfolio }: { portfolio: string }) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/charts/policies-charges/`
    }),
  getExistingPoliciesPerformanceData: ({ portfolio }: { portfolio: string }) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/charts/policies-performance/`
    }),
  // IPS charges recommended policies
  getRecommendedPoliciesChargesData: ({ portfolio }: { portfolio: string }) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/charts/policies-charges/?portfolio=recommended`
    }),
  // recommendation - total ongoing charges
  getTotalOngoingCharges: ({ portfolio }: { portfolio: string }) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/charts/portfolio-charges/`
    }),
  getTotalPerformanceData: ({ portfolio }: { portfolio: string }) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/charts/portfolio-performance/`
    }),
  // IPS - portfolio split
  getPortfolioSplitData: ({ portfolio }: { portfolio: string }) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/charts/portfolio-split/?portfolio=recommended`
    }),
  //  portfolio risk score && policy analysis
  getPortfolioRiskScore: ({ portfolio }: { portfolio: string }) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/charts/portfolio-risk-score/`
    }),
  // policy analysis
  getExistingPoliciesRiskScore: ({ portfolio }: { portfolio: string }) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/charts/policies-risk-score/`
    }),
  getRecommendedPoliciesRiskScore: ({ portfolio }: { portfolio: string }) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/charts/policies-risk-score/?portfolio=recommended`
    }),
  getPastPerformanceAggregateData: ({
    portfolio,
    data = {}
  }: {
    portfolio: string;
    data?: any;
  }) =>
    apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/charts/past-performance/?portfolio=aggregate_all`,
      data
    }),
  getAggregateCostAndCharges: ({
    portfolio,
    policyId
  }: {
    portfolio?: string;
    policyId?: number | null;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/charts/aggregate-cost-charges/${
        policyId ? `?portfolio=${policyId}` : ''
      }`
    }),
  getTypicalAssetAllocationEvalue: ({
    portfolio,
    recommendedRiskProfile,
    timeHorizon
  }: {
    portfolio?: string;
    recommendedRiskProfile: number | string;
    timeHorizon: number | string;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/charts/typical-asset-allocation/?risk_profile=${recommendedRiskProfile}&time_horizon=${timeHorizon}`
    }),
  getRiskAnalysisData: (
    { portfolio }: { portfolio: string },
    portfolioType?: string
  ) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/charts/portfolio-risk-analysis/${
        portfolioType ? `?portfolioType=${portfolioType}` : ''
      }`
    })
};
export default {
  ...chartsApi
};
